import CTASection from "../../../reusableUi/CTA";
import ServicesFAQs from "./ServicesFAQs";
import ServicesGrid from "./ServicesGrid";

export default function ServicesMain() {
  return (
    <main className="space-y-24">
      <ServicesGrid />
      <ServicesFAQs />
      <CTASection />
    </main>
  );
}
